import React from 'react'
import ImageWithBasePath from './ImageWithBasePath'
import { NextLink } from '../commonComponents/NextLink'

export const CreateProfileButton = ({ onClick = () => {} }) => {
  return (
    <NextLink
      href={{
        pathname: '/create_profile'
      }}
      isLoader={false}
      as={'/jobs/create_profile'}
      id="create_profile"
      onClick={onClick}
    >
      <div className="flex justify-between bg-[#024984] p-[12px]">
        <div>
          <div className="font-noto-sans text-[14px] font-normal leading-[16px] text-[#FFF]">
            90% more job chances if you have a job profile
          </div>
          <div className="mt-[4px] flex">
            <div className="mr-[4px] flex self-center font-noto-sans text-[14px] font-normal leading-[16px] text-[#FB0]">
              Create Profile
            </div>
            <div className="flex self-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={20}
                height={21}
                viewBox="0 0 20 21"
                fill="none"
              >
                <g clipPath="url(#clip0_1125_62217)">
                  <path
                    d="M4.16732 11.3333H13.4757L9.40898 15.3999C9.08398 15.7249 9.08398 16.2583 9.40898 16.5833C9.73398 16.9083 10.259 16.9083 10.584 16.5833L16.0757 11.0916C16.4007 10.7666 16.4007 10.2416 16.0757 9.9166L10.5923 4.4166C10.2673 4.0916 9.74232 4.0916 9.41732 4.4166C9.09232 4.7416 9.09232 5.2666 9.41732 5.5916L13.4757 9.6666H4.16732C3.70898 9.6666 3.33398 10.0416 3.33398 10.4999C3.33398 10.9583 3.70898 11.3333 4.16732 11.3333Z"
                    fill="#FFBB00"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_1125_62217">
                    <rect width={20} height={20} fill="white" transform="translate(0 0.5)" />
                  </clipPath>
                </defs>
              </svg>
            </div>
          </div>
        </div>
        <div className="ml-[24px]">
          <ImageWithBasePath src="suitcase" width={56} height={56} alt="Suitcase" />
        </div>
      </div>
    </NextLink>
  )
}